<template>
  <div>
    <!-- Snackbar cargando -->
    <v-snackbar v-model="isLoadingTrack" bottom :timeout="-1">
      Descargando datos del track
      <template #action="{ attrs }">
        <v-progress-circular v-on="attrs" indeterminate />
      </template>
    </v-snackbar>

    <!-- Snackbar errores -->
    <v-snackbar v-model="showSnackBar" color="error" bottom :timeout="5000">
      {{ msgSnackBar }}
    </v-snackbar>

    <vx-popup :datosPopup="datosPopup" :showPopup="showPopup" @clickBtn="clickBtn" @loadTrackFechas="loadTrackFechas" />

    <vx-track-fechas :show="showFechasDialog" @cancelar="showFechasDialog = false" @aceptar="loadTrackFechas" />

    <DetailsDialog
      :show="showDetailsDialog"
      :accionDialog="'Ver detalles'"
      :details="recursoSelected || {}"
      @close="showDetailsDialog = false"
    />
  </div>
</template>

<script>
import api from '../../../api'
import constants from '../../../helpers/constants'
import * as ArcGIS from '../../../helpers/ArcGIS'

import dayjs from 'dayjs'
import DateService, { FMT, DayjsUnit } from '@/helpers/DateService'

import Popup from './Popup'
import TrackFechas from './TrackFechas.vue'
import DetailsDialog from './DetailsDialog.vue'

function formatTipo (tipo) {
  return tipo ? tipo.replace(/_/g, ' ') : ''
}

export default {
  components: {
    'vx-popup': Popup,
    'vx-track-fechas': TrackFechas,
    DetailsDialog: DetailsDialog
  },

  data: () => ({
    showPopup: false,
    showDetailsDialog: false,
    rawPopupData: null, // Datos que devuelve el mapa
    attributes: null,
    recursoSelected: {},

    datosPopup: null, // Datos parseados que se le pasan al popup

    showFechasDialog: false,

    isLoadingTrack: false,
    tracksActivos: [],

    showSnackBar: false,
    msgSnackBar: ''
  }),

  computed: {
    medio () {
      return this.$store.getters['medio/getMedioByID'](this.attributes.ID_MEDIO)
    },
    medioTrack () {
      return this.$store.getters['medio/getMedioByID'](this.track.ID_MEDIO)
    },
    medioLogged () {
      return this.$store.getters['usuario/getUserLoggedInMedioByID'](this.attributes.ID_MEDIO)
    }
  },

  watch: {
    /* medioTrack () { // Hace que se repiten los tracks encima de si mismos
      if (this.isShowingTrack) {
        this.track.positions.unshift({MEDIO: {ID_MEDIO: this.medioTrack.ID_MEDIO, MEDIO: this.medioTrack.MEDIO}, LATITUD: this.medioTrack.LATITUD, LONGITUD: this.medioTrack.LONGITUD, FECHA: this.medioTrack.FECHA})
        this.showTrack(this.track.positions)
      }
    } */
  },

  methods: {
    onShowPopup (data) {
      this.rawPopupData = data
      this.datosPopup = null
      if (data) {
        this.attributes = data.attributes
        this.generarDatosMaptip()

        if (!this.attributes.notShowMaptip) {
          this.showPopup = true
        }
      } else {
        this.showPopup = false
      }
    },

    openDetailsDialog () {
      this.showDetailsDialog = true
    },

    generarDatosMaptip () {
      let layerId = this.rawPopupData.layer
      let attributes = this.rawPopupData.attributes

      let props = {
        x: this.rawPopupData.position.x,
        y: this.rawPopupData.position.y
      }
      let attrs = []
      let buttons = []

      if (layerId === 'layer-medios') {
        if (!attributes.notShowMaptip) {
          this.showButtonTimeSelectorIsochrone = true
          const popUpProps = this.popUpPosiciones(attributes)
          props.titulo = popUpProps.titulo
          attrs = popUpProps.attributes
          buttons = popUpProps.buttons

          this.recursoSelected = popUpProps.recurso
        }
      } else if (layerId === 'layer-track') {
        props.titulo = 'Track ' + attributes.MEDIO

        let velocidad = 0
        if (attributes.VELOCIDAD) {
          velocidad = attributes.VELOCIDAD
        }

        attrs = [
          { name: 'Fecha', value: dayjs(attributes.FECHA).format(FMT.date) },
          { name: 'Velocidad', value: velocidad + ' km/h' }
        ]
      } else if (layerId === 'layer-incendios') {
        props.titulo = attributes.LOCALIDAD

        attrs = [
          { name: 'Municipio', value: attributes.MUNICIPIO },
          { name: 'Localidad', value: attributes.LOCALIDAD },
          { name: 'Observaciones', value: attributes.OBSERVACIONES }
        ]

        buttons = [
          // {id: 'zoom', icon: 'zoom_in', tooltip: 'Zoom incendio', show: true}
        ]
      } else if (['layer-avion', 'layer-bomberos', 'layer-BRIF', 'layer-central-comunicaciones', 'layer-helicoptero', /* 'layer-pick-up', */ 'layer-repetidor-comunicaciones', /* 'layer-reten', */ 'layer-SOS', 'layer-torreta-vigilancia'].includes(layerId)) {
        props.titulo = attributes.TIPO

        attrs = [
          { name: 'Identificador', value: attributes.DENOMINAC },
          { name: 'Municipio', value: attributes.MUNICIPIO },
          { name: 'Altitud ', value: attributes.ALTITUD }
        ]
      } else if (layerId === 'layer-reten') {
        props.titulo = 'Base retén'

        attrs = [
          { name: 'Nombre', value: attributes.Nombre }
        ]
      } else if (layerId === 'layer-autobomba') {
        props.titulo = 'Base autobomba'

        attrs = [
          { name: 'Nombre', value: attributes.Nombre }
        ]
      } else if (layerId === 'layer-punto-encuentro') {
        props.titulo = 'Puntos de encuentro'

        attrs = [
          { name: 'Identificador', value: attributes.PUNTO },
          { name: 'Nombre', value: attributes.NOMBRE },
          { name: 'Municipio', value: attributes.MUNICIPIO },
          { name: 'Ubicación', value: attributes.UBICACION }
        ]
      } else if (layerId === 'layer-punto-agua-aer' || layerId === 'layer-punto-agua-ter') {
        props.titulo = 'Puntos de agua'

        attrs = [
          { name: 'Identificador', value: attributes.PUNTO },
          { name: 'Demarcación', value: attributes.DEMARCACIO },
          { name: 'Municipio', value: attributes.MUNICIPIO },
          { name: 'Núcleo de población', value: attributes.NUC_URB },
          { name: 'Paraje', value: attributes.PARAJE },
          { name: 'Superficie', value: attributes.SUPERFICIE },
          { name: 'Tipo', value: attributes.TIPO },
          { name: 'Estacional', value: attributes.ESTACIONAL },
          { name: 'Capacidad', value: attributes.CAPACIDAD },
          { name: 'Medios aéreos', value: attributes.MED_AEREO },
          { name: 'Altitud', value: attributes.ALTITUD },
          { name: 'Observaciones', value: attributes.OBSERVAC }
        ]
      } else if (layerId === 'layer-estaciones-meteorologicas') {
        props.titulo = attributes.DENOMINACI

        attrs = [
          { name: 'Tipo ', value: attributes.TIPO },
          { name: 'Denominación:', value: attributes.DENOMINACI }
        ]
      } else if (layerId === 'layer-montes-utilidad') {
        props.titulo = 'Montes utilidad pública'

        attrs = [
          { name: 'Identificador', value: attributes.id },
          { name: 'Nombre ', value: attributes.Nombre },
          { name: 'Código', value: attributes.Código_de },
          { name: 'Brigada', value: attributes.Brigada },
          { name: 'Comarca', value: attributes.Comarca },
          { name: 'Partido judicialicial', value: attributes.Partido_jud },
          { name: 'Municipio', value: attributes.Municipio },
          { name: 'Titular', value: attributes.Titular },
          { name: 'Superficie', value: attributes.Superficie }
        ]
      } else if (layerId === 'layer-plan-operaciones') {
        props.titulo = 'Plan de operaciones'

        attrs = []
        if (attributes.LONGITUD) {
          attrs.push({ name: 'Longitud', value: (Math.round(((attributes.LONGITUD / 1000) * 100)) / 100) + ' km' })
        }

        if (attributes.AREA) {
          attrs.push({ name: 'Área', value: (Math.round(((attributes.AREA / 10000) * 100)) / 100) + ' ha' })
        }
      } else if (layerId === 'layer-emergencias') {
        props.titulo = 'Emergencia'

        attrs = [
          { name: 'Medio', value: attributes.MEDIO },
          { name: 'Fecha', value: attributes.FECHA }
        ]
      } else if (layerId === 'layer-infraestructuras-propias') {
        props.titulo = attributes.NOMBRE
        attrs = [
          { name: 'Tipo', value: attributes.TIPO },
          { name: 'Categoria', value: attributes.CATEGORIA },
          { name: 'Codigo', value: attributes.CODIGO },
          { name: 'Municipio', value: attributes.MUNICIPIO },
          { name: 'Provincia', value: attributes.INE_PROVINCIA },
          { name: 'Responsable', value: attributes.RESPONSABLE },
          { name: 'Fecha alta', value: dayjs(attributes.FECHA_ALTA).format(FMT.date) },
          { name: 'Fecha baja', value: dayjs(attributes.FECHA_BAJA).format(FMT.date) },
          { name: 'Descripcion', value: attributes.DESCRIPCION },
          { name: 'Direcion', value: attributes.DIRECION }
        ]
      } else if (layerId === 'layer-perimetros') {
        props.titulo = 'Perímetro'
        attrs = [
          { name: 'Área (ha)', value: attributes.AREA },
          { name: 'Perímetro (km)', value: attributes.PERIMETRO }
        ]
      }

      this.datosPopup = {
        properties: props,
        attributes: attrs,
        buttons: buttons
      }

      /* if (!this.showIncendiosCards) {
        this.datosPopup.properties.x += 500
      } */
    },

    popUpPosiciones (attributes) {
      const attrs = [
        { name: 'Nombre', value: attributes.NOMBRE },
        { name: 'Alias', value: attributes.ALIAS },
        { name: 'Apellidos', value: attributes.APELLIDOS },
        { name: 'Teléfono', value: attributes.TELEFONO },
        { name: 'Identificador', value: attributes.MEDIO },
        { name: 'DNI/NIF', value: attributes.DNI },
        { name: 'Tipo', value: attributes.TIPO },
        { name: 'Base', value: attributes.BASE },
        { name: 'ISSI', value: attributes.ISSI },
        { name: 'Fecha ultima posición', value: dayjs(attributes.FECHA).format(FMT.date) },
        { name: 'Hora entrada', value: attributes.HORA_ENTRADA },
        { name: 'Hora salida', value: attributes.HORA_SALIDA },
        { name: 'Proveedor', value: attributes.PROVEEDOR }
      ]

      /**
     * Distinguir entre dispositivo o medio
     */
      // TODO: Aqui habrá problemas al cambiar de pintar 1 medio a pintar todos los dispositivos
      const trackActivo = this.tracksActivos.indexOf(this.attributes.ID_GEO_DISPOSITIVO) > -1

      const buttons = [
        // {id: 'zoom', icon: 'zoom_in', label: 'Zoom medio', visible: true},
        { id: 'showTrack', icon: 'mdi-map-marker', label: 'Mostrar ruta', visible: !trackActivo },

        { id: 'showRouting', icon: 'mdi-directions', label: 'Ir a', visible: !this.showRoutingIsochrone },
        { id: 'hideRouting', icon: 'mdi-eye-off', label: 'Ocultar Ir a', visible: this.showRoutingIsochrone },

        { id: 'showTrackFechas', icon: 'mdi-calendar', label: 'Mostrar ruta entre fechas', visible: !trackActivo },
        { id: 'hideTrack', icon: 'mdi-map-marker-off', label: 'Ocultar ruta', visible: trackActivo },
        { id: 'exportTrack', icon: 'mdi-download', label: 'Descargar SHP y KML', visible: trackActivo }
      ]

      return {
        titulo: attributes.ALIAS || attributes.NOMBRE,
        attributes: attrs,
        buttons
      }
    },

    clickBtn (btn) {
      if (btn === 'zoom') {
        this.zoom()
      } else if (btn === 'showTrack') {
        this.loadTrack()
      } else if (btn === 'hideTrack') {
        this.hideTrack()
      } else if (btn === 'exportTrack') {
        this.exportTrack()
      } else if (btn === 'showTrackFechas') {
        this.showFechasDialog = true
      } else if (btn === 'call') {
        this.callVideo()
      } else if (btn === 'viewDetails') {
        this.showDetailsDialog = true
      }

      this.showPopup = false
    },

    zoom () {
      let center = {
        target: [this.attributes.LONGITUDE, this.attributes.LATITUDE],
        zoom: 15
      }

      ArcGIS.setCenterMap(center)
    },

    async loadTrack () {
      let timeBack = constants.track.timeBackHours

      this.isLoadingTrack = true

      try {
        /**
         * Distinguir entre dispositivo o medio
         */
        let response = await api.medio.getTrackMedio(this.attributes.ID_GEO_DISPOSITIVO, timeBack)

        if (response.status === 200) { // TODO: reemplazar por 204 si no devuelve nada
          if (response.data.length >= 2) {
            this.showTrack(response.data)
          } else {
            this.msgSnackBar = 'El medio no dispone de track.'
            this.showSnackBar = true
          }
        }
      } catch (err) {
        this.$log.error('Error al obtener el track', err)
        this.msgSnackBar = 'Error al obtener el track.'
      } finally {
        this.isLoadingTrack = false
      }
    },

    async loadTrackFechas (data) {
      this.isLoadingTrack = true

      this.showFechasDialog = false

      let fechaInit = data.fechaInit
      let fechaFin = data.fechaFin

      try {
        /**
         * Distinguir entre dispositivo o medio
         */
        // let response = this.attributes.ID_GEO_DISPOSITIVO
        //   ? await api.medio.getTrackFechasMedio(this.attributes.ID_GEO_DISPOSITIVO, fechaInit, fechaFin)
        //   : await api.medio.getTrackFechasMedio(this.medio.ID_MEDIO, fechaInit, fechaFin)

        let response = await api.medio.getTrackFechasMedio(this.attributes.ID_GEO_DISPOSITIVO, fechaInit, fechaFin)

        if (response.status === 200) {
          if (response.data.length >= 2) {
            this.showTrack(response.data)
          } else {
            this.msgSnackBar = 'El medio no dispone de track.'
            this.showSnackBar = true
          }
        }

        if (response.status === 204) {
          this.msgSnackBar = 'El medio no dispone de track.'
          this.showSnackBar = true
        }
      } catch (err) {
        this.$log.error('Error al obtener el track', err)
        this.msgSnackBar = 'Error al obtener el track.'
      } finally {
        this.isLoadingTrack = false
      }
    },

    showTrack (posiciones) {
      let maxTimeDiference = constants.track.timeDiferenceTrackMinutes
      let maxPositions = constants.track.maxPositions

      // this.track.ID_MEDIO = posiciones[0].ID_MEDIO
      // this.track.MEDIO = posiciones[0].MEDIO
      // this.track.positions = []

      let positions = []
      for (let i = 0; i < posiciones.length; i++) {
        if (i === 0) {
          // this.track.positions.push(posiciones[i])
          positions.push(posiciones[i])
        } else {
          let dateLastPos = this.$date.parseDate(posiciones[i - 1].FECHA)
          let date = this.$date.parseDate(posiciones[i].FECHA)
          let difMinutes = dateLastPos.diff(date, DayjsUnit.Minute)

          if (difMinutes <= maxTimeDiference && positions.length <= maxPositions) { // this.track.positions
            // this.track.positions.push(posiciones[i])
            positions.push(posiciones[i])
          } else {
            continue
          }
        }
      }

      /**
       * Distinguir entre dispositivo o medio
       */
      let idTrack = this.attributes.ID_GEO_DISPOSITIVO
      let nameTrack = this.medio.MEDIO + '-' + this.attributes.PROVEEDOR

      ArcGIS.drawTrack(idTrack, nameTrack, positions, true)
      this.tracksActivos.push(idTrack)
      // this.setExtentTrack(this.track.positions)
      // this.$emit('drawTrack', this.medio.ID_MEDIO, positions) // this.track.positions
      // ArcGIS.drawTrack(this.medio.ID_MEDIO, this.medio.MEDIO, positions)
      // this.tracksActivos.push(this.medio.ID_MEDIO)
    },

    setExtentTrack (positions) {
      let latitud = []
      let longitud = []
      let extent = {}

      for (let i = 0; i < positions.length; i++) {
        latitud.push(positions[i].LATITUD)
        longitud.push(positions[i].LONGITUD)
      }
      extent.xmax = Math.max(...longitud)
      extent.xmin = Math.min(...longitud)
      extent.ymax = Math.max(...latitud)
      extent.ymin = Math.min(...latitud)
      extent.wkid = 4326
      this.$emit('setExtentMap', extent)
    },

    hideTrack () {
      /**
       * Distinguir entre dispositivo o medio
       */
      let index = this.attributes.ID_GEO_DISPOSITIVO
        ? this.tracksActivos.indexOf(this.attributes.ID_GEO_DISPOSITIVO)
        : this.tracksActivos.indexOf(this.medio.ID_MEDIO)

      if (index > -1) {
        this.tracksActivos.splice(index, 1)
      }
      /**
       * Ocultar dispositivo o medio
       */
      this.attributes.ID_GEO_DISPOSITIVO
        ? ArcGIS.hideTrack(this.attributes.ID_GEO_DISPOSITIVO)
        : ArcGIS.hideTrack(this.medio.ID_MEDIO)
    },

    exportTrack () {
      /**
       * Distinguir entre dispositivo o medio
       */
      this.attributes.ID_GEO_DISPOSITIVO
        ? ArcGIS.exportTrack({ idMedio: this.attributes.ID_GEO_DISPOSITIVO, medio: this.attributes.CODIGO_EXTERNO })
        : ArcGIS.exportTrack({ idMedio: this.medio.ID_MEDIO, medio: this.medio.MEDIO })
    },

    callVideo () {
      this.$store.dispatch('requestSharedCamera', this.medioLogged)
    }
  },

  mounted () {
    this.$eventHub.$on('showPopup', this.onShowPopup)
  }
}
</script>

<style scoped>

</style>
